import { createRoot } from 'react-dom/client';
import React from 'react';
import WindCreekClient from '../../../src/scripts/user-account/WindCreekClient.mjs';
import {
  getFirst3UniqueEvents,
  getCurrentDate,
  getDateString,
  getEndDate,
} from './utils.mjs';
import EventCard from './EventCard.mjs';
import ErrorPlaceholder from './ErrorPlaceholder.mjs';
import NoEventsPlaceholder from './NoEventsPlaceholder.mjs';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPlaceholder />;
    }

    return this.props.children;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const appDiv = document.getElementById('promotions-simple-app');
  let calendarTypeId = appDiv.dataset.calendarTypeId ?? null;
  calendarTypeId = parseInt(calendarTypeId) === 0 ? null : calendarTypeId;
  let propertyCode = WindCreekData.propertyCode;
  const startDate = getDateString(getCurrentDate());
  const endDate = getDateString(getEndDate());

  const root = createRoot(appDiv);

  // Aruba exception, since its code is `ARUBA` for the promotions only
  if (propertyCode === 'ACC') {
    propertyCode = 'ARUBA';
  }
  if (propertyCode === 'WCC') {
    propertyCode = 'WCI';
  }

  // API & Promos
  const wcc = new WindCreekClient();
  const queryBody = {
    operationName: "GetCalendar",
    variables: {
      input: {
        property: propertyCode,
        startDate: startDate,
        endDate: endDate,
        showUnpublishedEvents: false,
        showEmployeeOnlyEvents: null,
        calendarTypeId: calendarTypeId,
      }
    },
    query: `query GetCalendar($input: GetCommunityEventsCalendar!) {
      communityEventsCalendar(input: $input) {
        calendarDays {
          date
          eventIds
          __typename
        }
        events {
          eventId
          name
          imageUrl
          imageAlt
          shortDescriptionHeader
          startDate
          endDate
          startTime
          endTime
          detailsUrl
        }
        __typename
      }
    }`
  };

  wcc.query(queryBody)
    .then(response => {
      const data = response.data.communityEventsCalendar;
      const calendarDays = data.calendarDays;
      const events = data.events;

      const mappedCalendarDays = calendarDays.map(day => {
        if (events) {
          let dayEvents = day.eventIds.map(eventId =>
            events.find(event => event.eventId === eventId)
          );

          return { ...day, events: dayEvents };
        }

        return false;
      });

      const first3UniqueEvents = getFirst3UniqueEvents(mappedCalendarDays);

      root.render(
        <ErrorBoundary>
          <App
            events={first3UniqueEvents}
          />
        </ErrorBoundary>
      );
    })
    .catch(error => {
      console.error('Error:', error);

      root.render(
        <ErrorBoundary>
          <ErrorPlaceholder />
        </ErrorBoundary>
      );
    });
});

function App({ events }) {
  if (events.length > 0) {
    const eventDivs = events.map(event => {
      return (
        <EventCard
          key={'event-' + event.eventId}
          title={event.name}
          imgSrc={event.imageUrl}
          imgAlt={event.imageAlt}
          dateTimeOverride={event.shortDescriptionHeader}
          startDate={event.startDate}
          endDate={event.endDate}
          startTime={event.startTime}
          endTime={event.endTime}
          url={event.detailsUrl}
        />
      );
    });

    return (
      <>
        <h2 className="h2 text-primary mb-3">Featured Events</h2>

        <div className="promotions-simple row gy-3">
          {eventDivs}
        </div>
      </>
    );
  } else {
    return <NoEventsPlaceholder />;
  }
}
